import React from 'react'
import ReactDOM from 'react-dom'
import AddCardInvoice from './components/addCardInvoice'
import setTheme from './utils/setTheme'

setTheme()

document.addEventListener('DOMContentLoaded', () => {
  ReactDOM.render(<AddCardInvoice />, document.getElementById('add-card'))
})
